import { useState } from 'react'

import { cn } from '@/lib/utils'
import { auth } from '@/lib/auth'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

interface SignInCardProps extends React.ComponentProps<'div'> {
  redirect?: string
}

function resolveCallbackURL(redirect: string): string {
  if (typeof window === 'undefined') return redirect
  const path = redirect.startsWith('/') ? redirect : `/${redirect}`
  return `${window.location.origin}${path}`
}

export function SignInCard({
  redirect = '/',
  className,
  ...props
}: SignInCardProps) {
  const [error, setError] = useState<string | null>(null)

  const handleSignInWithGoogle = async () => {
    const { error: signInError } = await auth.signIn.social({
      provider: 'google',
      callbackURL: resolveCallbackURL(redirect),
    })

    if (signInError) {
      setError(signInError.message ?? 'Sign in failed. Please try again.')
    }
  }

  return (
    <div
      className={cn('flex flex-col gap-6 max-w-sm mx-auto', className)}
      {...props}
    >
      <Card>
        <CardContent>
          <Button
            onClick={() => void handleSignInWithGoogle()}
            className="w-full cursor-pointer"
          >
            Sign In With SUL Account
          </Button>
          {error && <p className="text-red-500">{error}</p>}
        </CardContent>
      </Card>
    </div>
  )
}
